import React from 'react';
import { motion } from 'framer-motion';
import { Activity } from 'lucide-react';
export function DashboardHeader() {
  return <motion.div initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="text-center space-y-4 py-8" data-id="element-67">
      <div className="inline-flex items-center justify-center gap-2 px-4 py-1.5 rounded-full bg-white/[0.05] border border-white/10 mb-4" data-id="element-68">
        <Activity className="w-4 h-4 text-salmon" data-id="element-69" />
        <span className="text-xs font-semibold tracking-widest text-salmon uppercase" data-id="element-70">
          Live Operation Status
        </span>
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-black tracking-tight uppercase text-white drop-shadow-lg" data-id="element-71">
        Calculadora Estratégica <br className="hidden md:block" data-id="element-72" />
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-white/60" data-id="element-73">
          COD Colombia
        </span>
      </h1>
      <p className="text-lg md:text-xl text-salmon/80 max-w-2xl mx-auto font-medium" data-id="element-74">
        Monitorea la salud real de tu operación en tiempo real.
      </p>
    </motion.div>;
}